<!-- DEPRECATED -->
<script>
	import { translate } from "$lib/utilities/translate";
	import { theme } from "$lib/utilities/theme";

	import MarkedContent from "$lib/components/MarkedContent.svelte";

	export let data;
	export let lang;
	export let col;
	export let settingId = "Document";

	$: markedContent = translate(
		data?.content?.[col]?.[settingId]?.content,
		lang,
	);
</script>

<section data-theme={$theme} class="w-full flex justify-center">
	<div class="max-w-[1440px] p-16">
		<div class="w-full">
			<MarkedContent {markedContent} />
		</div>
	</div>
</section>
